import { useQuery } from 'react-query';
import { formatSize } from 'pano-utils';
import memoizeOne from 'memoize-one';
import type { LibStorage } from '@types';
import { API_DOMAIN } from '@constants';
import { queryKeys } from '@queryClient';
import axios from '@utils/axios';
import { useTeamConfig } from '@utils/teamConfig';

type LibSpace = LibStorage & {
  remainStorage: number;
  remainStorageText: string;
};

const getStorageText = memoizeOne((data?: LibStorage) => {
  if (!data) return '';
  const totalStorage = data.levelStorage + data.shoppingStorage;
  const total =
    totalStorage > 1000000000000000 ? '不限' : formatSize(totalStorage);
  return `${formatSize(data.usedStorage)} / ${total}`;
});

export function useLibSpace(): LibSpace {
  const url = useTeamConfig(
    `${API_DOMAIN}/member/storage/summary`,
    `${API_DOMAIN}/team/app/tours/storage/summary`
  );
  const { data } = useQuery(queryKeys.libSpace, () => {
    return axios.get<LibStorage>(url);
  });
  if (!data) {
    return {
      levelStorage: 0,
      shoppingStorage: 0,
      usedStorage: 0,
      remainStorage: 0,
      remainStorageText: '',
    };
  }
  const { levelStorage, shoppingStorage, usedStorage } = data;
  return {
    levelStorage,
    shoppingStorage,
    usedStorage,
    remainStorage: levelStorage + shoppingStorage - usedStorage,
    remainStorageText: getStorageText(data),
  };
}
